import Vue from "vue";
import Vuex from "vuex";
import unifiedContentLibrary from '@pages/unifiedContentLibrary/store'

Vue.use(Vuex);
let isXnew = true;
let domin = window.document.domain;
if (domin.indexOf("xnews") != -1) {
  isXnew = true;
} else if (domin.indexOf("localhost") != -1) {
  isXnew = true;
} else {
  isXnew = false;
}
// isXnew=false
export default new Vuex.Store({
  state: {
    resourceType: localStorage.getItem('resourceType') || 'backConfirm',
    showAvatar: false,
    showUpload: false,
    showStorage: false,
    showMessage:false,
    quickEdit: false,
    messageList: [],
    create: {},
    flashPic1: false,
    scrollHide: false,
    isXnew,
    platform: isXnew ? "xnews" : "radio",
    user_space: {},
    useNum: 0,
    quick_edit_num: 0,
    selectList: [],
    isSelectAll: false,
    cancelSelect: 0,
    keyWord: '',
    tag: '',
    detailConfig: localStorage.getItem('detailConfig'),
    has_stream_send: false,
    sentimentNotice: false,
    has_datacenter: false,
    has_sentiment: false,
    newClient: '',
    icon: {
      guihuanqueren: false,
      yanqishenpi: false
    },
    randomDate: ''
  },
  mutations: {
    setMessageList(state, messageList) {
      state.messageList = messageList;
    },
    setCreate(state, create) {
      state.create = create;
    },
    setquickEdit(state, quickEdit) {
      state.quickEdit = quickEdit;
    },
    setflashPic1(state, flashPic1) {
      state.flashPic1 = flashPic1;
    },
    setScrollHide(state, scrollHide) {
      state.scrollHide = scrollHide;
    },
    setUserSpace(state, userSpace) {
      state.user_space = userSpace;
    },
    setUseNum(state, useNum) {
      state.useNum = useNum;
    },
    setShowAvatar(state){
      state.showAvatar = !state.showAvatar
    },
    setShowUpload(state){
      state.showUpload = !state.showUpload
    },
    setShowStorage(state){
      state.showStorage = !state.showStorage
    },
    setShowMessage(state){
      state.showMessage = !state.showMessage
    },
    setQuickEditNum(state, quick_edit_num){
      state.quick_edit_num = quick_edit_num
    },
    setSelectList(state, selectList){
      state.selectList = selectList
    },
    setIsSelectAll(state, isSelectAll){
      state.isSelectAll = isSelectAll
    },
    cancelSelect(state, cancelSelect){
      state.cancelSelect = cancelSelect
    },
    setKeyWord(state, keyWord){
      state.keyWord = keyWord
    },
    setTag(state, tag){
      state.tag = tag
    },
    setDetailConfig(state, detailConfig) {
      state.detailConfig = detailConfig
      localStorage.setItem('detailConfig', detailConfig)
    },
    setStreamSend(state, has_stream_send) {
      state.has_stream_send = has_stream_send
    },
    setSentimentNotice(state, sentimentNotice) {
      state.sentimentNotice = sentimentNotice
    },
    setHasDatacenter(state, has_datacenter) {
      state.has_datacenter = has_datacenter
    },
    setHasSentiment(state, has_sentiment) {
      state.has_sentiment = has_sentiment
    },
    setNewClient(state, newClient) {
      state.newClient = newClient
    },
    setResourceType(state, resourceType) {
      state.resourceType = resourceType
      localStorage.setItem('resourceType', resourceType)
    },
    changeRed(state, icon) {
      state.icon = icon
    },
    setRandomDate(state, randomDate) {
      state.randomDate = randomDate
    }
  },
  modules: {
    unifiedContentLibrary
  }
});
